import { Reducer } from 'redux'
import { handleActions } from 'redux-actions'
import { Action } from 'Types/action'
import { ActionTypes } from 'Src/constants/ActionType.constants'
import {
	SET_DASHBOARD_DATA,
	SET_DASHBOARD_PARAMS,
	SET_DASHBOARD_WIDGET_DATA,
	SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL,
	SET_DASHBOARD_PARTNER,
	SET_DASHBOARD_AVAILABLE_PRODUCTS,
	SET_DASHBOARD_WIDGETS_IS_LOADING,
	DashboardParams,
	DashboardData,
	CapabilityModel,
} from 'Pages/dashboard'

export type DashboardState = {
	data: Partial<DashboardData> | null
	dateInfo: DashboardParams
	isLoading: boolean
	openHeader: boolean
	showPartnerSelect: boolean
	selectedPartner: number | null
	capabilitiesWidget: {
		from: string
		to: string
		values: CapabilityModel[]
	}
	availableProducts: Record<number, string>
}

export const DashboardInitialState: DashboardState = {
	data: null,
	isLoading: true,
	dateInfo: new DashboardParams(),
	openHeader: false,
	showPartnerSelect: false,
	selectedPartner: null,
	capabilitiesWidget: {
		from: '',
		to: '',
		values: [],
	},
	availableProducts: {},
}

export const dashboard: Reducer<DashboardState> = handleActions<DashboardState, unknown>(
	{
		[ActionTypes.SET_DASHBOARD_DATA]: (
			state,
			action: Action<SET_DASHBOARD_DATA>
		): DashboardState => {
			const newState = { ...state }
			newState.data = action.payload
			return newState
		},
		[ActionTypes.SET_DASHBOARD_PARAMS]: (
			state,
			action: Action<SET_DASHBOARD_PARAMS>
		): DashboardState => ({
			...state,
			dateInfo: {
				...state.dateInfo,
				...action.payload,
			},
		}),
		[ActionTypes.GET_DASHBOARD_WIDGETS_DATA]: (state): DashboardState => ({
			...state,
			isLoading: true,
		}),
		[ActionTypes.SET_DASHBOARD_WIDGETS_IS_LOADING]: (
			state,
			action: Action<SET_DASHBOARD_WIDGETS_IS_LOADING>
		): DashboardState => ({ ...state, isLoading: action.payload }),
		[ActionTypes.SET_DASHBOARD_WIDGET_DATA]: (
			state,
			action: Action<SET_DASHBOARD_WIDGET_DATA>
		): DashboardState => ({
			...state,
			data: {
				...state.data,
				widgets_data: {
					...(state.data?.widgets_data || {}),
					from: action.payload.dateInfo.date_at,
					to: action.payload.dateInfo.date_to,
					[action.payload.widget_name]: action.payload.widget_data,
				},
			},
		}),
		[ActionTypes.SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL]: (
			state,
			action: Action<SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL>
		): DashboardState => ({
			...state,
			capabilitiesWidget: action.payload,
		}),
		[ActionTypes.CLEAR_DASHBOARD_DATA]: (): DashboardState => DashboardInitialState,
		[ActionTypes.SET_OPENED_HEADER]: (state): DashboardState => ({
			...state,
			openHeader: !state.openHeader,
		}),
		[ActionTypes.SHOW_DASHBOARD_PARTNER_SELECT]: (state): DashboardState => ({
			...state,
			showPartnerSelect: true,
		}),
		[ActionTypes.HIDE_DASHBOARD_PARTNER_SELECT]: (state): DashboardState => ({
			...state,
			showPartnerSelect: false,
		}),
		[ActionTypes.SET_DASHBOARD_PARTNER]: (
			state,
			action: Action<SET_DASHBOARD_PARTNER>
		): DashboardState => ({
			...state,
			selectedPartner: action.payload,
		}),
		[ActionTypes.SET_DASHBOARD_AVAILABLE_PRODUCTS]: (
			state,
			action: Action<SET_DASHBOARD_AVAILABLE_PRODUCTS>
		): DashboardState => ({
			...state,
			availableProducts: action.payload,
		}),
	},
	DashboardInitialState
)
